// eslint-disable-next-line no-unused-vars
import React from 'react';
import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service';

const INTERVAL = 10 * 1000;
const ALERT_SHOW_TIME = 25000;
const STATUS_NOT_FOUND = 404;
const STATUS_FAILED = -1;

export default class LoginRedirectService {
  timerId = null;
  showErrorIfRepeats = 3;
  errorOccureCounter = 0;

  /*@ngInject*/
  constructor($q, installerResource, installerAuth, wizardInfo) {
    this.$q = $q;
    this.installerAuth = installerAuth;
    this.wizardInfo = wizardInfo;
    this.bundleInstallationState = installerResource.bundleInstallationState;
  }

  openService() {
    window.location.href = window.location.href.replace('/login', '');
  }

  checkState() {
    return this.bundleInstallationState.get().$promise.
      then(res => !res.wizard && !res.starting).
      catch(err => {
        if (err.status !== STATUS_NOT_FOUND && err.status !== STATUS_FAILED) {
          return this.$q.reject(err);
        }

        //Handles case, when backend is not available anymore by this URL
        this.errorOccureCounter++;
        if (this.errorOccureCounter >= this.showErrorIfRepeats) {
          this.errorOccureCounter = 0;
          alertService.error(
            (
              <span>
                The {this.wizardInfo.productName} server is no longer available.<br/><br/>

                It might just be that the setup is complete and {this.wizardInfo.productName} has restarted. It could also mean that:<br/><br/>

                An administrator has stopped the server.<br/>
                An administrator has altered the configuration and is running the {this.wizardInfo.productName} service from a different web address.<br/>
                If you're not reconnected shortly, contact an administrator.
              </span>
            ),
            ALERT_SHOW_TIME
          );
        }

        return this.$q.reject(err);
      });
  }

  runPeriodicalCheck() {
    this.timerId = setTimeout(() => {
      this.checkState().
        then(isReady => {
          if (isReady) {
            this.openService();
          } else {
            this.runPeriodicalCheck();
          }
        }).
        catch(() => this.runPeriodicalCheck());
    }, INTERVAL);
  }

  stopPeriodicalCheck() {
    clearTimeout(this.timerId);
  }

  startRedirectWatcher() {
    this.runPeriodicalCheck();
    return () => this.stopPeriodicalCheck();
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login__redirect.js